module.exports = __webpack_public_path__ + "static/img/dayu_App_QR_Code.c3a8eca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dayu_App_QR_Code.jpg
// module id = E2W0
// module chunks = 0